import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { HiOutlineUserGroup } from "react-icons/hi2";
import "@fortawesome/fontawesome-free/css/all.min.css";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import DiscountIcon from "@mui/icons-material/Discount";
import HomeIcon from "@mui/icons-material/Home";
import PaidIcon from "@mui/icons-material/Paid";
import StarsIcon from "@mui/icons-material/Stars";

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <nav className="navbar">
      <div className="mobile-brand">Hill Group</div>
      <div className="menu-icon" onClick={handleClick}>
        <i className={click ? "fas fa-times" : "fas fa-bars"} />
      </div>
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li className="nav-item">
          <Link to="/home" className="nav-links" onClick={closeMobileMenu}>
            Home <HomeIcon />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/clients" className="nav-links" onClick={closeMobileMenu}>
            Klientet <HiOutlineUserGroup />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/transactions" className="nav-links" onClick={closeMobileMenu}>
            Transaksionet <PaidIcon />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/pos" className="nav-links" onClick={closeMobileMenu}>
            POS <AddLocationAltIcon />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/offers" className="nav-links" onClick={closeMobileMenu}>
            Ofertat <DiscountIcon />
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/bonuspointsvalue" className="nav-links" onClick={closeMobileMenu}>
            Vlera e Pikeve <StarsIcon />
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
